// extracted by mini-css-extract-plugin
export default {"fixed-height":"RichTextEditor_fixed-height__-0ibk"};